<div class="container">
  <div class="page-padding">
    <a class="cursor-pointer wallet-back-button d-flex align-items-center mb-3" (click)="goBack()">
      <span class="icon material-icons text-white me-1">keyboard_arrow_left</span>
      <span class="font-size-14">{{ 'rewards.wallet.back.btn' | translate }}</span>
    </a>
  </div>

  <fgbcl-marketplace-wallet-details [id]="id"></fgbcl-marketplace-wallet-details>
</div>
